import NextButton from 'modules/common/Navbar/popovers/AgendaPopover/NextButton';
import { CarouselProps } from 'nuka-carousel';

const settings: CarouselProps = {
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  easing: 'easeLinear',
  cellSpacing: 24,
  edgeEasing: 'easeLinear',
  cellAlign: 'left',
  heightMode: 'max',
  dragging: false,
  swiping: false,
  renderCenterCenterControls: null,
  renderCenterLeftControls: null,
  renderCenterRightControls: null,
  renderBottomLeftControls: null,
  renderBottomCenterControls: null,
  renderBottomRightControls: null,
  renderTopRightControls: NextButton,
  renderTopCenterControls: null,
};

export default settings;
